import { BathProductPage, BathProductConfig } from "@/components/bath/BathProductPage";

const config: BathProductConfig = {
  slug: "vena-vanity",
  category: "Vanity Console",
  productName: "VENA Vanity Console — Integrated Bathroom Vanity",
  shortName: "VENA Vanity",
  sku: "VENA-VANITY-1200",
  schemaCategory: "Bathroom Vanities > Wall-Hung > Solid Surface",
  metaTitle: "VENA Vanity Console — Integrated Bathroom Vanity | Aureum VII",
  metaDescription:
    "VENA Vanity Console — integrated solid surface vanity with seamless basin and timber joinery for luxury hotels and residences. MOQ-ready.",
  heroEyebrow: "Project Solutions · Vanity Console",
  heroHeadline: (
    <>
      Integrated{" "}
      <span className="bg-gradient-to-r from-amber-300 via-amber-400 to-amber-200 bg-clip-text text-transparent">
        Vanity Console
      </span>{" "}
      with Seamless Basin
    </>
  ),
  heroIntro:
    "A wall-hung vanity console pairing a seamless solid surface top-and-basin with warm timber joinery. VENA Vanity ships as a complete, specifier-friendly unit — engineered for hotels, branded residences and high-end refurbishments.",
  premiumSummary:
    "A complete vanity console: seamless solid surface top with integrated basin, wall-hung timber carcass, and concealed soft-close drawers. Designed and priced for project-scale specification.",
  galleryImages: [
    {
      src: "/images/bath/vena-vanity.jpg",
      alt: "VENA vanity console integrated solid surface basin and timber cabinet — hero",
      title: "VENA Vanity — Hero",
      caption: "Hero · Integrated vanity console",
      description: "Hero shot of the VENA vanity console with seamless solid surface top and warm walnut joinery.",
    },
    {
      src: "/images/bath/vena-vanity-detail.jpg",
      alt: "VENA vanity seamless integrated basin solid surface detail",
      title: "VENA Vanity — Basin Detail",
      caption: "Detail · Integrated basin",
      description: "Macro detail of the VENA vanity's seamless integrated basin cast in solid surface stone-resin.",
    },
    {
      src: "/images/bath/vena-vanity-side.jpg",
      alt: "VENA vanity console side profile wall-hung timber carcass",
      title: "VENA Vanity — Side Profile",
      caption: "Profile · Wall-hung",
      description: "Side profile of the VENA vanity showing the wall-hung timber carcass and slim solid surface top.",
    },
    {
      src: "/images/bath/vena-vanity-suite.jpg",
      alt: "VENA vanity console installed in luxury hotel suite bathroom",
      title: "VENA Vanity — Suite Lifestyle",
      caption: "Lifestyle · Hotel suite",
      description: "Lifestyle scene: VENA vanity specified in a five-star hotel guest bathroom with stone walls.",
    },
    {
      src: "/images/bath/vena-vanity-residence.jpg",
      alt: "VENA vanity console in private residence primary bathroom",
      title: "VENA Vanity — Residence Lifestyle",
      caption: "Lifestyle · Private residence",
      description: "Lifestyle scene: VENA vanity in a private residence primary bathroom with micro-cement floors.",
    },
  ],
  specs: [
    { label: "Dimensions", value: "1200 × 480 × 480 mm (W × D × H)" },
    { label: "Top & Basin", value: "Cast Solid Surface (seamless integrated bowl)" },
    { label: "Carcass", value: "Walnut veneer · Oak / Black available" },
    { label: "Finish", value: "Matte White top · Brushed metal pulls" },
    { label: "Installation", value: "Wall-hung (concealed steel bracket included)" },
    { label: "Drawers", value: "2 × soft-close drawers · concealed runners" },
    { label: "Weight", value: "≈ 38 kg" },
    { label: "Tap Hole", value: "Pre-drilled 35 mm (wall-mount option)" },
    { label: "Certification", value: "CE Marked · E1 board emissions" },
    { label: "Warranty", value: "5 years structural · 2 years hardware" },
    { label: "MOQ (Container)", value: "Bulk pricing from 15+ units" },
  ],
  longDescription: [
    "VENA Vanity Console is a complete integrated vanity: a seamless solid surface top with cast-in basin, wall-hung onto a warm timber carcass with two soft-close drawers. Specifiers receive a single unit ready to install — no separate basin, top or bracket sourcing required.",
    "The solid surface top is non-porous and refinishable, while the carcass is built from low-emission E1 board with real timber veneer. Concealed steel brackets carry the load cleanly off the wall, leaving the floor open for a lighter, more architectural read.",
    "Specified by hotel groups, branded residences and high-end developers across Europe. Trade pricing, MOQ-ready supply, and OEM finishing (carcass colour, hardware, dimensions) available for project-scale orders.",
  ],
};

const VenaVanity = () => <BathProductPage config={config} />;
export default VenaVanity;
